import React from 'react';

import { Button } from '@material-ui/core';
import { useSelector, connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { setHeightUnit } from 'store/actions/heightUnit/setHeightUnit';
import Tooltip from '@material-ui/core/Tooltip';
import { HEIGHT_UNITS } from 'consts/units';
import ButtonsUseStyles from 'consts/styles/Buttons';
import { useStyles } from './HeightUnitSwitchUseStyles';

const HeightUnitSwitch = props => {
  const { heightUnit } = props;
  const dispatch = useDispatch();
  const subtitles = useSelector(state => state.language).sidebar;
  const classes = useStyles();
  const classesButtons = ButtonsUseStyles();

  const handleChange = () => {
    if (heightUnit === HEIGHT_UNITS.meters)
      dispatch(setHeightUnit(HEIGHT_UNITS.feets));
    else if (heightUnit === HEIGHT_UNITS.feets)
      dispatch(setHeightUnit(HEIGHT_UNITS.meters));
  };

  return (
    <Tooltip title={subtitles.heightUnit_} placement="left-start" arrow>
      <Button
        className={`${classes.Switch} ${classesButtons.Buttons} ${classesButtons.ButtonsCircle} ${classesButtons.Buttons}--color`}
        onClick={handleChange}
      >
        {heightUnit}
      </Button>
    </Tooltip>
  );
};

const mapStateToProps = state => ({
  heightUnit: state.heightUnit,
});

HeightUnitSwitch.propTypes = {
  heightUnit: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(HeightUnitSwitch);
